import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, Paper, Typography, Button, CircularProgress } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

const EntityJsonViewerPage = ({ title, fetchUrl }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const res = await axios.get(fetchUrl(id));
        setData(res.data);
      } finally {
        setLoading(false);
      }
    };
    if (id) load();
  }, [id, fetchUrl]);

  return (
    <Box>
      <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)} sx={{ mb: 2 }}>
        Back
      </Button>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>{title}</Typography>
        {loading ? (
          <CircularProgress />
        ) : (
          <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {JSON.stringify(data, null, 2)}
          </pre>
        )}
      </Paper>
    </Box>
  );
};

export default EntityJsonViewerPage;

